import axiosInstance from '../utils/axios';

export interface ResponsibleLoginParams {
  phone: string;
  password?: string; // 密码登录（保留兼容性）
  code?: string; // 验证码登录
}

export interface SendCodeParams {
  phone: string;
}

export interface ResponsibleUserInfo {
  id: number;
  name: string;
  phone: string;
  role: string;
}

class ResponsibleAuthService {
  // 发送短信验证码
  async sendVerificationCode(params: SendCodeParams): Promise<any> {
    try {
      const response = await axiosInstance.post('/sms/send-code', params);
      return response.data;
    } catch (error) {
      console.error('发送验证码失败:', error);
      throw error;
    }
  }

  // 验证码登录
  async loginWithCode(params: ResponsibleLoginParams): Promise<{ token: string; user: ResponsibleUserInfo }> {
    try {
      const response = await axiosInstance.post('/sms/verify-login', params);
      const { token, user } = response.data;
      
      // 保存token到localStorage（统一使用token）
      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(user));
      
      return { token, user };
    } catch (error) {
      console.error('验证码登录失败:', error);
      throw error;
    }
  }

  // 原密码登录（保留兼容性，开发环境使用）
  async login(params: ResponsibleLoginParams): Promise<{ token: string; user: ResponsibleUserInfo }> {
    try {
      // 如果是验证码登录，调用新的接口
      if (params.code) {
        return this.loginWithCode(params);
      }
      
      // 否则调用原来的密码登录接口
      const response = await axiosInstance.post('/responsible/login', params);
      const { token, user } = response.data;
      
      // 保存token到localStorage（统一使用token）
      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(user));
      
      return { token, user };
    } catch (error) {
      console.error('负责人登录失败:', error);
      throw error;
    }
  }

  logout(): void {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  }

  getToken(): string | null {
    return localStorage.getItem('token');
  }

  getUser(): ResponsibleUserInfo | null {
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  }

  isAuthenticated(): boolean {
    return !!this.getToken();
  }
}

export const responsibleAuthService = new ResponsibleAuthService(); 